import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you offer mobile tinting services in Towson?',
      answer: (
        <>
          Yes! Our <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile window tinting service</a> brings professional installation to your home, office, or preferred location in Towson and surrounding areas.
        </>
      ),
    },
    {
      question: 'What window tinting services do you provide in Towson?',
      answer: (
        <>
          We provide <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">ceramic and standard automotive tinting</a>, <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial building tinting</a>, <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight and taillight tinting</a>, and <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">custom vehicle decals</a>.
        </>
      ),
    },
    {
      question: 'How long does it take to tint a car in Towson?',
      answer: 'Most vehicle tinting takes 2-4 hours depending on the vehicle type. We offer same-day service for Towson residents and can work around your schedule with flexible appointment times.',
    },
    {
      question: 'What are Maryland\'s window tinting laws?',
      answer: 'In Maryland, front side windows must allow more than 35% light transmission. Rear windows and back windshields can be darker. We ensure all our installations meet Maryland legal requirements.',
    },
    {
      question: 'Should I choose ceramic or standard window tint?',
      answer: 'Ceramic tint offers superior heat rejection, 99% UV protection, no signal interference, and never fades. Standard tint provides good UV protection at a lower cost. We can help you choose based on your needs and budget.',
    },
    {
      question: 'Which Towson areas do you serve?',
      answer: 'We serve all of Towson including Towson University area, Downtown Towson, Hampton, Lutherville-Timonium, Ruxton, Riderwood, and surrounding Baltimore County neighborhoods.',
    },
    {
      question: 'Is there a warranty on your window tinting?',
      answer: 'Yes! All our tinting services come with a lifetime warranty covering peeling, bubbling, fading, and discoloration. We use only premium materials and professional installation methods.',
    },
    {
      question: 'Can you tint commercial properties in Towson?',
      answer: (
        <>
          Absolutely! We specialize in <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial window tinting</a> for offices, retail stores, and buildings in Towson. Commercial tinting reduces cooling costs and enhances privacy.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Towson
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
